// Classes
import CCliente from '../cliente/CCliente';
import CUsuario from '../usuario/CUsuario';
import type CMonitoramentoTempoUso from './CMonitoramentoTempoUso';
import type CResultadoAgregacao from '../temas/base/CResultadoAgregacao';
import type CResponseConsultaPaginada from '../base/CResponseConsultaPaginada';

// Enums
import EPlataforma from '@/shared/enums/EPlataforma';
import ENivelUsuarioERP from '@/shared/enums/ENivelUsuarioERP';

export class CRegistroTempoDeUsoAplicacao {
  tempoEmMs: number = 0;
  acessos: number = 0;
  usuario: string = '';
  nivel: ENivelUsuarioERP = ENivelUsuarioERP.Indefinido;
  cliente: string = '';
  dia: number = 0;
  mes: number = 0;
  ano: number = 0;
  plataforma: EPlataforma = EPlataforma.Desconhecido;

  timestamp: number = 0;

  constructor(pResponse: CResultadoAgregacao<CMonitoramentoTempoUso>) {
    this.acessos = pResponse.metricas?.count_sessaoId ?? this.acessos;
    this.tempoEmMs = pResponse.metricas?.sum_tempoEmMS ?? this.tempoEmMs;

    this.dia = pResponse.agregacao?.dia ?? this.dia;
    this.mes = pResponse.agregacao?.mes ?? this.mes;
    this.ano = pResponse.agregacao?.ano ?? this.ano;

    const lUsuario = pResponse.agregacao?.usuario ? new CUsuario(pResponse.agregacao?.usuario as any) : new CUsuario();
    const lCliente = pResponse.agregacao?.cliente ? new CCliente(pResponse.agregacao?.cliente as any) : new CCliente();

    this.usuario = lUsuario.codigo + ' - ' + lUsuario.nome;
    this.cliente = lCliente.codigo + ' - ' + lCliente.descricao;
    this.nivel = lUsuario.nivel;

    this.plataforma = pResponse.agregacao?.plataforma ?? this.plataforma;
    this.timestamp = new Date(this.ano, this.mes - 1, this.dia).getTime();
  }
}

export default class CRelatorioTempoDeUsoAplicacao {
  registros: CRegistroTempoDeUsoAplicacao[] = [];

  constructor(pResponse?: CResponseConsultaPaginada<CResultadoAgregacao<CMonitoramentoTempoUso>>) {
    if (pResponse) {
      this.processar(pResponse);
    }
  }

  processar(pResponse: CResponseConsultaPaginada<CResultadoAgregacao<CMonitoramentoTempoUso>>) {
    for (const registro of pResponse.registros) {
      this.registros.push(new CRegistroTempoDeUsoAplicacao(registro));
    }
  }
}
